import { createPortal } from 'react-dom';
import IconClose from './icon_close.svg';
import s from './index.module.scss';

export const CenterModalWrapper = ({ children, onClose }) => {
  return createPortal(
    <div className={s.wrapper}>
      <div className={s.backdrop} onClick={onClose} />
      <div className={s.content}>
        <img
          className={s.btn_close}
          src={IconClose}
          alt="close"
          width={24}
          height={24}
          onClick={onClose}
        />
        {children}
      </div>
    </div>,
    document.body,
  );
};
